import { VarianteChip } from '../ui';
import { ItemPlano, PlanoCotacaoResumo } from '../api/plano-cotacao/planoCotacaoApi';

/**
 * Regras de apresentação dos planos de cotação (at-69, frente D/D7).
 *
 * Como em `termoTemplateRegras`, nada aqui **decide** — o backend já manda
 * `tipoVeiculoConhecido` e `tipoVeiculoAtivo` resolvidos (at-43/at-44). Estas
 * funções compõem o rótulo e, principalmente, trazem para texto visível as duas
 * explicações que viviam em `title` na tabela antiga.
 */

export interface RotuloTipoNoSga {
  texto: string;
  variante: VarianteChip;
  descricao: string;
}

/**
 * O estado do tipo de veículo do plano **no espelho do SGA**.
 *
 * ⚠️ **São dois problemas diferentes, e a at-44 os separou de propósito:** o
 * código pode ter sumido do espelho ("não encontrado") ou existir e estar marcado
 * INATIVO lá. Nos dois casos o plano continua válido no banco; o que muda é que o
 * tipo não aparece para seleção na cotação. `null` = está tudo certo.
 */
export function rotuloTipoNoSga(plano: PlanoCotacaoResumo): RotuloTipoNoSga | null {
  if (!plano.tipoVeiculoConhecido) {
    return {
      texto: 'não encontrado no SGA',
      variante: 'pendente',
      descricao:
        'Este código não está no espelho de tipos de veículo do SGA. O plano continua válido, mas o tipo não aparece para seleção.',
    };
  }

  if (!plano.tipoVeiculoAtivo) {
    return {
      texto: 'inativo no SGA',
      variante: 'pendente',
      descricao:
        'O SGA marcou este tipo de veículo como inativo. Ele não aparece para seleção, mesmo que o plano esteja ativo.',
    };
  }

  return null;
}

/**
 * **Plano ativo precisa ter conteúdo** — regra do backend desde a at-43, que
 * recusa com 400 a ativação de um plano com as três seções vazias (sem ela o PDF
 * sairia sem Coberturas, Assistências nem Benefícios, em silêncio).
 *
 * A ficha passa a **dizer antes**, junto do checkbox, em vez de deixar o TI
 * descobrir no erro do servidor. ⚠️ Isto **não substitui** a guarda do backend: é
 * pré-checagem, e por isso replica exatamente o mesmo critério.
 */
export function planoAtivoSemConteudo(
  ativo: boolean,
  secoes: { coberturas: ItemPlano[]; assistencias: ItemPlano[]; beneficios: ItemPlano[] },
): boolean {
  if (!ativo) return false;

  return (
    secoes.coberturas.length + secoes.assistencias.length + secoes.beneficios.length === 0
  );
}
